import * as React from "react";
import { useHistory } from "react-router-dom";

// Components
import QuestionProgressBar from "../QuestionProgressBar/QuestionProgressBar";
import IconClose from "../Icons/IconClose";

// Style
import "./QuestionStickyHeader.scss";

interface QuestionStickyHeader {
  progress: number;
  categoryId: string;
}

const QuestionStickyHeader: React.FC<QuestionStickyHeader> = (
  props: QuestionStickyHeader
) => {
  const { progress, categoryId } = props;
  const history = useHistory();

  return (
    <div className="question-sticky bg-dw-grey-01 relative z-40">
      <div className="question-sticky__container w-11/12 max-w-screen-xl mx-auto relative h-full pb-3">
        <IconClose
          className="icon-close cursor-pointer transition-opacity ease-out duration-300"
          onClick={() => {
            if (
              // eslint-disable-next-line no-alert
              window.confirm(
                "Do you really want to close? All unsaved progress in this question will be lost."
              )
            ) {
              history.push(`/category/${categoryId}`);
            }
          }}
        />
      </div>
      <QuestionProgressBar progress={progress} />
    </div>
  );
};

export default QuestionStickyHeader;
